import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

export class BreadCrumbExportBillingL10n {
  public static exportBilling = _('breadcrumb.exportBilling');
  public static monthlyExport = _('breadcrumb.monthlyExport');
  public static exportsList = _('breadcrumb.exportList');
}
